import React from 'react'

/* doc
---
title: Notification
name: Notification
category: React - Bulma
---

A `Notification` component for alerting users of something. This is a wrapper for Bulma's `.notification` element.

See [Bulma Documentation](https://bulma.io/documentation/elements/notification/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <Notification/>
```
@TODO add support for <button class="delete"></button>

*/
function Notification(props) {
  const { children, className, ...rest } = props

  const classes = [
    'notification',
    className || '',
  ]

  return (
    <div className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default Notification
